module.exports = __webpack_public_path__ + "img/Прямоугольник_17.svg?70c369765ad8514871e5edf741bbdfee";